module.exports = {"newsletter":{"title":"Les chiffres de la semaine dans votre boite à lettres","text":"Abonnez-vous à la newsletter {link}, et vous recevrez toutes les semaines un récapitulatif des dernières tendances de l'univers JavaScript!","button":"S'abonner","placeholder":"Votre email"},"view_project":{"twitter":{"text":"En {year}, avec plus de {delta} étoiles gagnées sur GitHub, {name} a été {category} numéro {ranking}.","action":"Tweet"},"months":"J F M A M J J A S O N D","created":"Créé","homepage":"Site web"}}


//////////////////
// WEBPACK FOOTER
// ./i18n/common/fr.yaml
// module id = 451
// module chunks = 230186691558513